import React from "react";
import { Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import "./transferIdDialog.css";

interface TransferIdActionDialogProps {
  open: boolean;
  status: string;
  handleCancel: () => void;
  handleSubmit: () => void;
}

const TransferIdActionDialog: React.FC<TransferIdActionDialogProps> = ({
  open,
  handleCancel,
  handleSubmit,
  status,
}) => {
  return (
      <Modal
        open={open}
        width={400}
        className="model"
        closable={false}
        cancelText="No"
        okText="Yes"
        onCancel={handleCancel}
        onOk={handleSubmit}
        title={
          <span>
            {" "}
            <ExclamationCircleOutlined
              style={{ color: "orange", marginRight: "8px", fontSize: "17px" }}
            />
            {`${status === "enabled" ? "Disable" : "Enable"} Transfer ID`}
          </span>
        }
        centered={true}
        okButtonProps={{
          style: { backgroundColor: "#008576", color: "white" },
        }}
        cancelButtonProps={{ className: "custom-cancel-button" }}
      >
        <div style={{ marginLeft: "30px" }}>
          {status === "enabled"
            ? "Are you sure you want to disable this Transfer ID? It will no longer be available to users."
            : "Are you sure you want to enable this Transfer ID? Enabling the Transfer ID will make it available to users."}
        </div>
      </Modal>
  );
};

export default TransferIdActionDialog;
